import Headroom from 'headroom.js';
import { CountUp } from 'countup.js';
import Cookie from 'js-cookie';

export default () => {
  let navBar = document.querySelector('nav.uk-navbar-container');
  new Headroom(navBar, {
    offset: 0,
    tolerance : {
      up : 0,
      down : 15
    },
  }).init();

  // TODO: Test multiple instances
  UIkit.util.on(document, 'inview', '.component--statistics-counter', function (evt) {
    let countElements = document.querySelectorAll('[data-counter]');

    for (let index = 0; index < countElements.length; index++) {
      let counterValue = countElements[index].dataset.counter

      let counter = new CountUp(countElements[index], counterValue, {
        duration: 3
      });

      counter.start();
    }
  });

  UIkit.util.on('[uk-alert].announcement-banner', 'hidden', () => {
    Cookie.set('lcs_announcement_closed', 1);
  });

  // TODO: Test multiple instances
  UIkit.util.on('[uk-slider].image-slider', 'itemshow', function (evt, el) {
    let backgroundSlider = $(el.$el).parent().parent();
    let instance = backgroundSlider.data('instance');

    UIkit.slideshow(`[data-instance="${instance}"] [uk-slideshow]`).show(el.index);
  });

  // TODO: Test multiple instances
  UIkit.util.on('[uk-slider].testimonials', 'itemshow', function (evt, el) {
    let instance = $(el.$el).parent().parent().data('instance');

    $(`[data-instance="${instance}"] ul.uk-slider-items li`).removeClass('is-centered');

    if ($(evt.target).next().length) {
      $(evt.target).next().addClass('is-centered');
    } else {
      $(`[data-instance="${instance}"] ul.uk-slider-items li`).eq(0).addClass('is-centered');
    }
  });
};



// WEBPACK FOOTER //
// ./resources/js/views/site.js